/**
 * Formula tokenizer. Splits a Smartsheet-syntax formula string into tokens.
 * A leading `=` (the sheet's formula marker) is stripped. Whitespace is skipped.
 */
export function tokenize(src) {
    const toks = [];
    const s = src.startsWith('=') ? src.slice(1) : src;
    let i = 0;
    while (i < s.length) {
        const c = s[i];
        if (c === ' ' || c === '\t' || c === '\n' || c === '\r') {
            i++;
            continue;
        }
        if (c === '"') { // "string literal"  (Smartsheet doubles "" to escape a quote)
            let j = i + 1;
            let str = '';
            while (j < s.length) {
                if (s[j] === '"') {
                    if (s[j + 1] === '"') {
                        str += '"';
                        j += 2;
                        continue;
                    }
                    break;
                }
                str += s[j];
                j++;
            }
            toks.push({ t: 'str', v: str });
            i = j + 1;
            continue;
        }
        if (c === '[') { // [Column Label] optionally followed by @row
            let j = i + 1;
            let name = '';
            while (j < s.length && s[j] !== ']') {
                name += s[j];
                j++;
            }
            j++; // past ]
            if (s.slice(j, j + 4).toLowerCase() === '@row')
                j += 4;
            toks.push({ t: 'col', v: name.trim() });
            i = j;
            continue;
        }
        if (c === '{') { // {CONSTANT}
            let j = i + 1;
            let name = '';
            while (j < s.length && s[j] !== '}') {
                name += s[j];
                j++;
            }
            toks.push({ t: 'const', v: name.trim() });
            i = j + 1;
            continue;
        }
        if (/[0-9]/.test(c) || (c === '.' && /[0-9]/.test(s[i + 1] ?? ''))) {
            let j = i;
            let numStr = '';
            while (j < s.length && /[0-9.]/.test(s[j])) {
                numStr += s[j];
                j++;
            }
            toks.push({ t: 'num', v: parseFloat(numStr) });
            i = j;
            continue;
        }
        if (/[A-Za-z_]/.test(c)) {
            let j = i;
            let id = '';
            while (j < s.length && /[A-Za-z0-9_]/.test(s[j])) {
                id += s[j];
                j++;
            }
            toks.push({ t: 'id', v: id });
            i = j;
            continue;
        }
        const two = s.slice(i, i + 2);
        if (two === '<=' || two === '>=' || two === '<>') {
            toks.push({ t: 'op', v: two });
            i += 2;
            continue;
        }
        if ('+-*/=<>(),'.includes(c)) {
            toks.push({ t: 'op', v: c });
            i++;
            continue;
        }
        // Unknown character — skip it (defensive; parser will surface real problems).
        i++;
    }
    return toks;
}
//# sourceMappingURL=tokenizer.js.map